module.exports = __webpack_public_path__ + "img/logo-header.deeb7982.png";